import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import {
    deletePersonalVaultAdministration,
    getDeletePersonalVaultAdministrationMutationOptions,
    getListPersonalVaultsAdministrationQueryKey,
    type PersonalVaultAdministration,
} from '@/modules/api/codegen';
import { actions as messagesActions } from '@/modules/messages';

import { personalVaultOwnerLabel } from '../utils';

// Mirrors `useDeleteVault`: takes the whole vault so the success message can name its owner, and
// reports both outcomes itself since mutations bypass the shared query cache's `onError`.
export const useDeletePersonalVault = () => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: getDeletePersonalVaultAdministrationMutationOptions().mutationKey,
        mutationFn: (vault: PersonalVaultAdministration) => deletePersonalVaultAdministration({ vaultId: vault.id }),
        onSuccess: async (_, vault) => {
            await queryClient.invalidateQueries({ queryKey: getListPersonalVaultsAdministrationQueryKey() });

            dispatch(
                messagesActions.displaySuccessMessage({
                    message: { id: 'vaults.table.actions.delete.personal.success', values: { owner: personalVaultOwnerLabel(vault) } },
                    options: { duration: 5 },
                }),
            );
        },
        onError: () =>
            dispatch(
                messagesActions.displayErrorMessage({
                    message: { id: 'vaults.table.actions.delete.error' },
                    options: { duration: 5 },
                }),
            ),
    });
};
